import AnimatedImage from 'core-lib/components/AnimatedImage';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { AddToCartType } from 'src/modules/parkplusStoreV2/types/cart';
import { PdpPropType } from 'src/modules/parkplusStoreV2/types/product';
import AddToCart from 'src/modules/parkplusStoreV2/uiComponents/AddToCart';
import MoreProductDetails from 'src/modules/parkplusStoreV2/uiComponents/PdpComponents/MoreProductDetails';
import StoreAppBar from 'src/modules/parkplusStoreV2/uiComponents/StoreAppBar';
import { Divider } from 'ui-v2/components/Divider';
import { Typography } from 'ui-v2/components/Typography';
import s from './ExternalVoucherPdp.module.scss';

export const ExternalVoucherPdp = ({ data }: PdpPropType) => {
  return (
    <div className={s.root}>
      <StoreAppBar
        showCart
        showFuel
        title=""
        showShare
        renderAppBarOnly
      />
      <div className={s.header}>
        <AnimatedImage src={data?.descriptionImages[0]} alt='descriptionImage' />
        <div className={s.icon}>
          <AnimatedImage src={data?.icon} alt='dataIcon' />
        </div>
      </div>
      <div className={s.coreDetails}>
        <Typography
          label={data?.subtitle1}
          variant="label_3_medium"
          color="secondary"
        />
        <Typography label={data?.title} variant="label_2_medium" />
        <div className={s.mlBenifit}>
          <Typography
            label={("ml benefit applied").toUpperCase()}
            variant="label_3_semi_bold"
            color="positive"
          />
          <Typography
            label={`Claim for ${formatFuelBalance(data?.loyaltyPoints)}`}
            variant="label_3_semi_bold"
            color="positive"
          />
        </div>
      </div>
      <Divider variant="padded" />
      {data?.productHighlights && (
        <>
          <div className={s.highlights}>
            <div className={s.inner}>
              {data?.productHighlights?.map((item) => {
                return (
                  <div className={s.item} key={item?.title}>
                    <div className={s.icon}>
                      <AnimatedImage
                        src={item.icon}
                        customStyle={{
                          width: '48px',
                          height: '48px',
                        }}
                        alt='productHighlight'
                      />
                    </div>
                    <div className={s.head}>
                      <Typography
                        label={item.title}
                        variant="label_4_medium"
                        color="tertiary"
                      />
                    </div>
                    <Typography label={item.subtitle} variant="label_2_semi_bold" />
                  </div>
                );
              })}
            </div>
          </div>
          <Divider variant="padded" />
        </>
      )}

      <MoreProductDetails data={data} />
      <AddToCart product={data} type={AddToCartType.ProductDescription} />
    </div>
  );
};
